import script from "./WebFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./WebFooter.vue?vue&type=script&setup=true&lang=js"

import "./WebFooter.vue?vue&type=style&index=0&id=24f34380&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f34380"]])

export default __exports__
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QNoSsr from 'quasar/src/components/no-ssr/QNoSsr.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QFooter,QNoSsr,QSeparator,QBtn,QIcon});
